module.exports = __webpack_public_path__ + "static/img/member18.b73f8f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/member18.jpg
// module id = 0Ae4
// module chunks = 0